import { Component } from "@angular/core";

@Component({
    selector:"app-mb-footer",
    templateUrl: "./mb-footer.component.html",
})
export class MBFooterComponent{
    year = new Date().getFullYear()
}